import React from "react";
import { motion } from "framer-motion";
import { WHY, PROCESS, Reveal, stagger } from "../../lib/site";

export const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-section" className="bg-navy py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <span className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-gold">
            03 — Why Choose Us
          </span>
          <h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-white max-w-2xl text-balance">
            The advantages of trading with AM Ventures
          </h2>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-16 grid gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/5 sm:grid-cols-2 lg:grid-cols-4"
        >
          {WHY.map((w) => {
            const Icon = w.icon;
            return (
              <motion.div
                key={w.title}
                variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.6 } } }}
                data-testid={`why-item-${w.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group bg-navy p-7 transition-colors duration-300 hover:bg-navy-tint"
              >
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-gold/10 text-gold transition-all duration-300 group-hover:bg-gold group-hover:text-[#0B1F3A]">
                  <Icon size={22} />
                </span>
                <h3 className="mt-5 font-display text-lg font-medium text-white">{w.title}</h3>
                <p className="mt-2 text-sm text-slate-300 leading-relaxed">{w.text}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="bg-navy-deep py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-gold">
                04 — Our Process
              </span>
              <h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-white">
                From enquiry to delivery
              </h2>
              <p className="mt-6 text-slate-300 leading-relaxed max-w-sm">
                A disciplined, transparent five-step process that removes friction from international trade.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="relative">
              <div className="absolute left-[27px] top-2 bottom-2 w-px bg-white/10" />
              {PROCESS.map((p, i) => (
                <motion.div
                  key={p.n}
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.7, delay: i * 0.08, ease: [0.76, 0, 0.24, 1] }}
                  data-testid={`process-step-${p.n}`}
                  className="group relative flex gap-7 pb-10 last:pb-0"
                >
                  <div className="relative z-10 grid h-14 w-14 shrink-0 place-items-center rounded-full border border-white/15 bg-navy font-display text-lg font-semibold text-slate-300 transition-all duration-300 group-hover:border-gold group-hover:bg-gold group-hover:text-[#0B1F3A]">
                    {p.n}
                  </div>
                  <div className="pt-2">
                    <h3 className="font-display text-xl md:text-2xl font-medium text-white">{p.title}</h3>
                    <p className="mt-2 text-slate-300 leading-relaxed max-w-lg">{p.text}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
